import React from 'react';

const SelectedPropertyItem = ({ label, onRemove, removeTitle }) => (
    <div
        className="btn btn-gray"
        style={{
            position: 'relative',
            display: 'block',
            marginBottom: '4px',
        }}
    >
        {label}
        <span
            style={{
                position: 'absolute',
                right: '5px',
            }}
            title={removeTitle}
            className="c-hand"
            onClick={onRemove}
        >
            <i className="icon icon-cross" />
        </span>
    </div>
);

export default SelectedPropertyItem;